import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.background.default,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(6),
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
    textAlign: 'center',
    maxWidth: 450,
    width: '100%',
  },
  iconWrapper: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    background: theme.palette.gradients.brandingMain,
    color: theme.palette.common.white,
    boxShadow: '0 4px 12px rgba(32, 185, 148, 0.24)',
  },
  iconWrapperWarning: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    background: theme.palette.gradients.blueGradient,
    color: theme.palette.common.white,
    boxShadow: '0 4px 12px rgba(0, 170, 224, 0.24)',
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  },
  message: {
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    marginBottom: theme.spacing(4),
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  primaryButton: {
    padding: theme.spacing(1.5, 4),
    borderRadius: theme.spacing(1),
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    background: theme.palette.gradients.brandingMain,
    color: theme.palette.common.white,
    textDecoration: 'none',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    border: 'none',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
  },
  secondaryButton: {
    padding: theme.spacing(1.5, 4),
    borderRadius: theme.spacing(1),
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    background: 'transparent',
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    border: `1px solid ${theme.palette.divider}`,
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
    },
  },
  linkButton: {
    padding: theme.spacing(1.5, 4),
    borderRadius: theme.spacing(1),
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    background: theme.palette.gradients.brandingMain,
    color: theme.palette.common.white,
    textDecoration: 'none',
    textAlign: 'center',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      textDecoration: 'none',
      color: theme.palette.common.white,
    },
  },
}));
